import axios from "axios";
import notification from 'ant-design-vue/es/notification'

axios.defaults.headers["Content-Type"] = "application/json;charset=utf-8";
// 创建axios实例
const service = axios.create({
  // axios中请求配置有baseURL选项，表示请求URL公共部分
  baseURL: 'https://generate.djketc.com/',
  // baseURL: 'http://127.0.0.1:8086/',
  // 超时
  timeout: 60000,
});
// request拦截器
service.interceptors.request.use(
  (config) => {
    // 是否需要设置 token
    const token = localStorage.getItem('token')
    if (token) {
      config.headers['Authorization'] = token
    }
    return config;
  },
  (error) => {
    console.log(error);
    Promise.reject(error);
  }
);

// 响应拦截器
service.interceptors.response.use(
  (success) => {
    if (success.status && success.status == 200 && success.data.status == 500) {
      notification.error({
        message: success.data.msg
      });
      return;
    }
    if (success.data.code == 100004 || success.data.code == 70004) {
      notification.error({
        message: success.data.message ?
          success.data.message : "尚未登录，请登录",
      });
      location.href = "/";
    }
    if (success.data.msg) {
      notification.success({
        message: success.data.msg
      });
    }
    return success.data;
  },
  (error) => {
    // if (error.response.status == 401) {
    //   this.$message.error({
    //     message: error.response.data.msg ?
    //       error.response.data.msg : "尚未登录，请登录",
    //   });
    //   location.href = "/";
    // } else {
    if (error.response.data.msg) {
      notification.error({
        message: error.response.data.msg
      });
    } else {
      notification.error({
        message: "未知错误!"
      });
    }
    // }
    return Promise.reject(error);
  }
);

export default service;
